import { render, staticRenderFns } from "./DepartmentManage.vue?vue&type=template&id=3db01cb5&"
import script from "./DepartmentManage.vue?vue&type=script&lang=js&"
export * from "./DepartmentManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports